// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3nKTU","title":"ClientInsurance_title__286K1","itemText":"ClientInsurance_itemText__gN2Lt"};